import { Component, OnDestroy } from '@angular/core';
import {
    AbstractControl,
    FormBuilder,
    FormControl,
    FormGroup,
    ValidationErrors,
} from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import {
    AccountActions,
    ClubActions,
    ClubSelectors,
    DefaultModalComponent,
    ModalOverlayRef,
    ModalsService,
    ModulesSelectors,
} from '@serviceos-ng/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

function validateCancelReasonForm(
    form: AbstractControl
): ValidationErrors | null {
    const reason = form.get('reason')?.value || null;
    const comment = form.get('comment')?.value || '';

    if (reason && reason.requires_comment == false) {
        return null;
    }

    if (
        reason &&
        reason.requires_comment &&
        comment.replace(/\s/g, '').length
    ) {
        return null;
    }

    if (reason == null && comment.replace(/\s/g, '').length) {
        return null;
    }

    return {
        formError: true,
    };
}

@Component({
    selector: 'serviceos-web-club-cancel-modal',
    templateUrl: './club-cancel-modal.component.html',
    styleUrls: ['./club-cancel-modal.component.scss'],
})
export class ClubCancelModalComponent implements OnDestroy {
    public formStep = 1;

    cancelReasonForm: FormGroup;

    @Select(ClubSelectors.getBenefits)
    benefitsConfig$!: Observable<any>;

    @Select(ClubSelectors.cancelReasons)
    cancelReasons$!: Observable<any>;

    @Select(ModulesSelectors.getComponentFromModule('membership', 'cancellation' ))
    componentConfig$!: Observable<any>

    private cancelClub!: {
        cancel_membership_reason_id: number;
        comment: string;
    };

    public modalsContent;

    constructor(
        private modalRef: ModalOverlayRef,
        private store: Store,
        public fb: FormBuilder,
        public _modalsService: ModalsService
    ) {
        this.modalsContent = this.store.selectSnapshot(
            ModulesSelectors.getComponentFromModule('membership', 'cancellation' )
        );

        this.cancelReasonForm = this.fb.group(
            {
                reason: '',
                comment: '',
            },
            { validator: validateCancelReasonForm }
        );
    }

    ngOnDestroy(): void {
        this.store.dispatch(new ClubActions.ResetCancelReasons());
    }

    submitSelectReasonStep() {
        const formValue = this.cancelReasonForm.value;

        if(!this.cancelReasonForm.errors?.formError){

            this.cancelClub = {
                cancel_membership_reason_id: formValue.reason.id,
                comment: formValue.comment,
            };

            if (this.modalsContent?.confirm) {
                this.completeFirstDialog();
            } else if (this.modalsContent?.claim_deal) {
                this.submitClaimDealStep();
            } else if (this.modalsContent?.final_confirm) {
                this.submitFinalConfirmStep();
            } else {
                this.submitCancelMembership();
            }  
        }
    }

    submitCancelMembership() {
        this.store
            .dispatch(new ClubActions.MembershipCancel(this.cancelClub))
            .subscribe((res) => {
                this.store.dispatch(new AccountActions.Fetch())
                this.formStep = 2;
            });
    }

    completeFirstDialog() {

        const dialogContent = this.modalsContent.confirm;

        const dialogRefMembershipCancelConfirm = this._modalsService
            .open(DefaultModalComponent, {
                componentData: {
                    title: dialogContent.title ? dialogContent.title : '',
                    message: dialogContent.content ? dialogContent.content : '',
                    buttons: [
                        {
                            title: dialogContent.confirm_button_title ? dialogContent.confirm_button_title : 'End membership',
                            type: 'confirm'
                        },
                        {
                            title: dialogContent.cancel_button_title ? dialogContent.cancel_button_title : 'Keep Membership',
                            type: 'close',
                        }
                    ]
                },
                backdropClickClose: true,
            });
            
        dialogRefMembershipCancelConfirm.close$.pipe(take(1)).subscribe((res) => {
            if (res === 'confirm') {
                if (this.modalsContent?.claim_deal) {
                    this.submitClaimDealStep();
                } else if (this.modalsContent?.final_confirm) {
                    this.submitFinalConfirmStep()
                } else {
                    this.submitCancelMembership();
                }
            } else {
                this.close();
            }
        });
    }

    submitClaimDealStep() {

        const dialogContent = this.modalsContent.claim_deal; 

        const dialogRefMembershipCancelClaimDeal = this._modalsService
            .open(DefaultModalComponent, {
                componentData: {
                    title: dialogContent.title ? dialogContent.title : '',
                    message: dialogContent.content ? dialogContent.content : '',
                    buttons: [
                        {
                            title: dialogContent.confirm_button_title ? dialogContent.confirm_button_title : 'End membership',
                            type: 'confirm'
                        },
                        {
                            title: dialogContent.cancel_button_title ? dialogContent.cancel_button_title : 'Keep Membership',
                            type: 'close',
                        }
                    ]
                },
                backdropClickClose: true,
            });

            dialogRefMembershipCancelClaimDeal.close$.pipe(take(1)).subscribe((res) => {
                if(res === 'confirm') {
                    if (this.modalsContent?.final_confirm) {
                        this.submitFinalConfirmStep()
                    } else {
                        this.submitCancelMembership();
                    }
                } else {
                    this.store.dispatch(new ClubActions.ClaimDeal(7112, 34));
                    this.close();
                }
            });
    }
    submitFinalConfirmStep() {

        const dialogContent = this.modalsContent.final_confirm;

        const dialogRefMembershipCancelNegativeVibe = this._modalsService
            .open(DefaultModalComponent, {
                componentData: {
                    title: dialogContent.title ? dialogContent.title : '',
                    message: dialogContent.content ? dialogContent.content : '',
                    buttons: [
                        {
                            title: dialogContent.confirm_button_title ? dialogContent.confirm_button_title : 'End membership',
                            type: 'confirm'
                        },
                        {
                            title: dialogContent.cancel_button_title ? dialogContent.cancel_button_title : 'Keep Membership',
                            type: 'close',
                        }
                    ]
                },
                backdropClickClose: true,
            });

        dialogRefMembershipCancelNegativeVibe.close$.pipe(take(1)).subscribe((res) => {
            if(res === 'confirm') {
                this.submitCancelMembership();
            } else {
                this.close();
            }
        });
    }

    close() {
        this.modalRef.close();
    }
}
